module.exports = __webpack_public_path__ + "img/right2.9cd6646.png";